import React, { useState } from "react";
import {Dialog} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Typography} from "../../../../designSystem/components/Typography";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const LongMenuEditor = ({ items, onChangeItems }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const add = () =>
    onChangeItems([...(items || []), { label: "新選項", text: "" }]);

  const update = (i: number, v: any) =>
    onChangeItems(items.map((item, idx) => (idx === i ? v : item)));

  const remove = (i: number) => {
    onChangeItems(items.filter((_, idx) => idx !== i))
    setSelectedIndex(null)
  }

  return (
    <React.Fragment>
      <div className="flex flex-1 items-center gap-3 overflow-x-auto px-5">
        {items?.length > 0 && (
          <div className="flex flex-row gap-x-2 justify-start overflow-visible item-start">
            {items.map((item, i) => (
              <div
                key={i}
                className={`cursor-pointer py-2 px-1 ${i === selectedIndex ? `border-2 border-amber-300 ` : 'border-2 border-gray-50'}`}
                onClick={() => setSelectedIndex(i === selectedIndex ? null : i)}
              >
                {/* 顯示的 chip */}
                <div
                  className="
                    rounded-3xl bg-ptTeal px-3 py-2 text-white cursor-default
                    whitespace-nowrap overflow-hidden text-ellipsis max-w-[160px]
                  "
                >
                  {item.label || "未命名"}
                </div>
              </div>
            ))}
          </div>
        )}

        <ActionButton
          label="新增選項"
          iconName="fa-plus"
          color="secondary"
          variant="dashed"
          onClick={add}
        />
      </div>

      <Dialog
        open={selectedIndex !== null}
        onClose={() => setSelectedIndex(null)}
        PaperProps={{sx: { borderRadius: 6 }}}
      >
        <div className="p-8 flex flex-col gap-8">
          <Typography variant="title">
            編輯選項
          </Typography>
          <BaseInput
            value={items?.[selectedIndex]?.label ?? ""}
            onChange={(e) => update(selectedIndex, {...items[selectedIndex], label: e.target.value})}
            label="顯示文字"
          />
          <BaseInput
            value={items?.[selectedIndex]?.text ?? ""}
            onChange={(e) => update(selectedIndex, {...items[selectedIndex], text: e.target.value})}
            label="回應文字"
          />
          <div className="flex flex-row justify-between gap-4">
            <ActionButton
              label="儲存"
              iconName="fa-save"
              variant="outline"
              onClick={() => setSelectedIndex(null)}
            />
            <ActionButton
              label="刪除"
              iconName="fa-trash"
              color="warning"
              variant="outline"
              onClick={() => remove(selectedIndex)}
            />
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};